import "./WhyChooseSection.css"

const WhyChooseSection = () => {
  return (
    <section className="why-choose-section">
      <div className="why-choose-container">
        <h2 className="why-choose-title">
          <span className="why">Why Choose</span>&nbsp;<br></br>
          <span className="polymath-kids">Polymath-Kids?</span>
        </h2>

        {/* Ring Image */}
        <div className="ring-image">
          <img src={require("../assets/ring.png") || "/placeholder.svg"} alt="Ring" />
        </div>

        {/* Teacher with Student Image */}
        <div className="teacher-student-image">
          <img
            src={require("../assets/teacher-looking-her-little-student.png") || "/placeholder.svg"}
            alt="Teacher with student"
          />
        </div>

        {/* Fun Learning */}
        <div className="fun-learning-icon">
          <img src={require("../assets/fun-icon.png") || "/placeholder.svg"} alt="Fun Learning" />
        </div>
        <div className="fun-learning-text">
          <h3>FUN LEARNING</h3>
          <p>Real-World, Hands-On<br />Projects</p>
        </div>

        {/* Endless Activities */}
        <div className="endless-activities-icon">
          <img src={require("../assets/activities-icon.png") || "/placeholder.svg"} alt="Endless Activities" />
        </div>
        <div className="endless-activities-text">
          <h3>ENDLESS ACTIVITIES</h3>
          <p>Create, Practice, Explore</p>
        </div>

        {/* STEM Certified */}
        <div className="stem-icon">
          <img src={require("../assets/stem-icon.png") || "/placeholder.svg"} alt="STEM Certified" />
        </div>
        <div className="stem-text">
          <h3>STEM CERTIFIED</h3>
          <p>Trusted Global Standards</p>
        </div>

        {/* Fun Competitions */}
        <div className="competition-icon">
          <img src={require("../assets/competition-icon.png") || "/placeholder.svg"} alt="Fun Competitions" />
        </div>
        <div className="competition-text">
          <h3>FUN  COMPETITIONS</h3>
          <p>Learn, Compete, And Grow</p>
        </div>

        {/* Age-Based Content */}
        <div className="age-based-icon">
          <img src={require("../assets/age-icon.png") || "/placeholder.svg"} alt="Age-Based Content" />
        </div>
        <div className="age-based-text">
          <h3>AGE-BASED CONTENT</h3>
          <p>Right Level For Every Age</p>
        </div>

        {/* Diverse Courses */}
        <div className="courses-icon">
          <img src={require("../assets/courses-icon.png") || "/placeholder.svg"} alt="Diverse Courses" />
        </div>
        <div className="courses-text">
          <h3>DIVERSE COURSES</h3>
          <p>Learn Skills That Matter</p>
        </div>

        {/* Expert Teachers */}
        <div className="teacher-icon">
          <img src={require("../assets/teacher-icon.png") || "/placeholder.svg"} alt="Expert Teachers" />
        </div>
        <div className="teacher-text">
          <h3>EXPERT TEACHERS</h3>
          <p>Guided By Top Mentors</p>
        </div>

        {/* CEO Quote Block */}
        <div className="ceo-quote">
          <p>
            "Learning Contemporary Skills Is A Necessity. Polymath-Kids Ambitiously Seeks To Provide Knowledge Of A
            Variety Of Subjects And Topics To Help Develop 21st Century Life Skills, Which Are Critical For The Next
            Generation. It Helps Our Young Ones By Developing New Ways Of Thinking, Problem-Solving, Making Informed
            Decisions And Meeting The Needs And Demands Of Today's Dynamic World."
          </p>
          <div className="ceo-signature">
            <p className="ceo-name">Maryam Hamad</p>
            <p className="ceo-title">Founder & CEO, Polymath-Kids.com</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WhyChooseSection
